export const isEven = (number) => {
    return number % 2 === 0;
  }